import { useQuery } from "react-query";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { getErrorMessage } from "helpers";
import { merchantTerminalService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";
import { TerminalSolutionViewDto } from "types/api";

import getDefaultValuesTerminalSolution from "../terminalSolutions/getDefaultValuesTerminalSolution";

type useGetTerminalQueryProps = {
	terminalId: string;
	redirectTo?: string;
	terminalAccessoryTypes?: { [key: string]: any }[];
	merchantGeneralData?: any;
	onSuccess?: Function;
	enabled?: boolean;
	merchantId: string;
};

const useGetTerminalSolutionByMerchantQuery = ({
	terminalId,
	redirectTo,
	terminalAccessoryTypes,
	merchantGeneralData,
	onSuccess,
	enabled = true,
	merchantId,
}: useGetTerminalQueryProps) => {
	const dispatch = useDispatch();
	const history = useHistory();

	const queryResult = useQuery(
		["getTerminalSolution", terminalId, merchantId],
		() =>
			merchantTerminalService.getTerminalSolutionById(
				terminalId,
				merchantId,
			),
		{
			retry: 0,
			select: (data: TerminalSolutionViewDto) => {
				const terminalSolution: any = getDefaultValuesTerminalSolution({
					data,
					terminalAccessoryTypes,
					merchantGeneralData,
				});

				return terminalSolution;
			},
			onSuccess: data => {
				onSuccess?.(data);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
				redirectTo && history.push(redirectTo);
			},
			enabled: enabled && !!terminalId && !!merchantId,
			cacheTime: 0,
		},
	);

	return queryResult;
};

export default useGetTerminalSolutionByMerchantQuery;
